module.exports = require("./vai-Vaii-LR");